import { useQuery } from '@tanstack/react-query'
import type { GetAccountResponse } from 'backend/types'
import { getAccount } from '@/lib'
import { queryKeys } from '@/lib/queryKeys'

interface UseAccountOptions {
  enabled?: boolean
}

/** アカウント情報を取得するカスタムフック */
export function useAccount(options: UseAccountOptions = {}) {
  const { enabled = true } = options

  return useQuery<GetAccountResponse, Error>({
    queryKey: queryKeys.account,
    queryFn: async () => {
      return getAccount()
    },
    enabled,
  })
}
